module.exports = __webpack_public_path__ + "img/logo-1.9dfbe07e.svg";